<particle-treaty-status-viewer class="w-p-100" *ngIf="id" [id]="id" [sourceKey]="parentSourceKey">

</particle-treaty-status-viewer>

<div class="w-p-100 flex flex-col justify-start items-start full-grow-no-shrink-no-basis">
    <mat-accordion class="custom-accordion w-p-100 m-t-11">
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div *ngIf="type == 'Dynamic'">
                    {{country1.name}} tax treaties with all other countries
                </div>

            </mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>

                <particle-treaty-status-viewer [id]="id1" [sourceKey]="firstCountrySourceKey">

                </particle-treaty-status-viewer>

            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div *ngIf="type == 'Dynamic'">
                    {{country2.name}} tax treaties with all other countries
                </div>
            </mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>
                <particle-treaty-status-viewer [id]="id2" [sourceKey]="secondCountrySourceKey">

                </particle-treaty-status-viewer>
            </ng-template>
        </mat-expansion-panel>
    </mat-accordion>
</div>


